import React, { useState } from 'react';
import { Grid, Box, Typography, makeStyles, Checkbox, Button, Tooltip, IconButton, useTheme, Stack, Accordion, AccordionSummary, AccordionDetails, ImageListItemBar, ImageListItem } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditIcon from '@material-ui/icons/Edit';
import { PictureAsPdf, Description } from '@material-ui/icons';
import axios from 'axios';
import { REST_API_END_POINT, REST_API } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import { Icon } from '@iconify/react';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moment from 'moment';
import jsPDF from 'jspdf';
import PDFEditor from 'src/components/_dashboard/official-request/PDFEditor';
import AttachmentDownloadIconButton from 'src/components/_dashboard/official-request/AttachmentDownloadIconButton';
import AttachmentPreviewDialog from 'src/components/_dashboard/official-request/AttachmentPreviewDialog';


const useStyles = makeStyles((theme) => ({
    attachmentBox: {
        cursor: 'pointer',
        display: 'flex',
        borderRadius: '6px',
        backgroundColor: '#172e34',
        padding: theme.spacing(1),
        margin: theme.spacing(1, 0),
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative', 
        height: '100px', 
        overflow: 'hidden'
    },
    attachmentIcon: {
        marginRight: theme.spacing(1),
    },
    delete:{
        m:2,
        display:'flex',
        justifyContent:'flex-end' 
      },
    checkbox: {
        position: 'absolute',
        top: theme.spacing(1), 
        right: theme.spacing(1), 
    },
    checkboxContainer: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
    },
    dialogContent: {
        padding: theme.spacing(3),
        maxWidth: 768,
        margin: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    gridContainer: {
        height: 'auto',
    },
}));

export default function ProjectFileAttach({ data, setFetchData, refresh, setRefresh, projectId, designOrder, requestId ,hasViewCostPermission=true}) {
    const classes = useStyles();
      const theme = useTheme()
    
    let user = JSON.parse(localStorage.getItem('user'))
    const isClient = user?.isClient
    const userType = isClient ? 3 : user?.user_type
    const canDownloadFiles = !isClient && userType !== 3
    const explodedPermissions = user?.exploded_permissions
    const { enqueueSnackbar } = useSnackbar()
    const [open, setOpen] = useState(false);
    const [selectedAttachment, setSelectedAttachment] = useState(null);
    const [pdfLoading, setPdfLoading] = useState(true);
    const [useOfficeViewer, setUseOfficeViewer] = useState(true);
    const [checkedItems, setCheckedItems] = useState([]);
    const [openPDFEditor, setOpenPDFEditor] = useState(false);
    const [selectedPDFForEdit, setSelectedPDFForEdit] = useState(null);

    const attachmentToFile = (attachment) =>
        attachment
            ? {
                  ...attachment,
                  url:
                      attachment.file_url ||
                      attachment.url ||
                      attachment.name ||
                      attachment.upload_file_name,
                  file_type: attachment.file_type,
                  name: attachment.upload_file_name || attachment.name,
              }
            : null

    const handleCheckboxChange = (id) => {
        console.log('idddddddd',id)
        setCheckedItems((prevState) => {
            const isPresent = prevState.includes(id);
            const updatedState = isPresent
              ? prevState.filter((item) => item !== id)
              : [...prevState, id];
            return updatedState;
          });   
    };

    //   const handleUpdateDesign = () => {

    //     const data = { id: id, status: 0, num: 4 }
    //     axios
    //       .post(`${REST_API_END_POINT}request/update-designs`, data)
    //       .then((res) => {
    //       })
    //   }
     
    const handleDelete=async()=>{
        try {
            let apiUrl = '';
            if(designOrder){
                apiUrl = `design-order-job/delete-attachment`
            }else{
                apiUrl = `project-task/delete-project-attachment`
            }
            const res = await axios.post(`${REST_API_END_POINT}${apiUrl}`,{
            // const res = await axios.post(`${REST_API_END_POINT}project-task/delete-project-attachment`,{
                userId:user.user_id,attachments:checkedItems,projectId,
            })
            if(res.data.status===1){
                const attachmentsToUpdate = data.filter(
                    (attachment) => checkedItems.includes(attachment.ID) && attachment.not_approved_image === 1
                  );
            
                  if (attachmentsToUpdate.length > 0) {
                    const updatePromises = attachmentsToUpdate.map((attachment) =>
                      axios.post(`${REST_API_END_POINT}request/update-designs`, {
                        requestId: attachment.request_id,
                        userId: user.user_id,
                        id: attachment.ID,
                        status: 0,
                        num: 4,
                      })
                    );
            
                    // Wait for all updates to complete
                    await Promise.all(updatePromises);
                  }
                enqueueSnackbar(res.data.message,{variant:'success'}) 
                setRefresh(!refresh)
                setCheckedItems([])
                if(designOrder){
                    setFetchData(true)
                  }
            }else{
                enqueueSnackbar(res.data.message,{variant:'error'}) 
            }
        } catch (error) {
            console.log(error)
        }
      }

    const handleAttachmentClick = (attachment) => {
        setSelectedAttachment(attachment);
        setOpen(true);
    };

    const getDocumentSource = (attachment) =>
        attachment.not_approved_image === 1
            ? 'request'
            : designOrder
                ? 'design_order'
                : 'estimate_project';

    const handleDownloadEditedPdf = async (attachmentId, documentSource) => {
        try {
            const res = await axios.post(
                `${REST_API_END_POINT}request/get-attachment-images`,
                { attachmentId, documentSource }
            );
            const images = res.data?.images;
            if (!images || !images.length) {
                enqueueSnackbar('No edited pages available to download', { variant: 'error' });
                return;
            }
            const pdf = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' });
            const pdfPageWidth = pdf.internal.pageSize.getWidth();
            const pdfPageHeight = pdf.internal.pageSize.getHeight();
            const baseUrl = REST_API.endsWith('/') ? REST_API : `${REST_API}/`;
            for (let i = 0; i < images.length; i++) {
                const image = images[i];
                const imagePath = (image.image_url || '').startsWith('/') ? image.image_url.slice(1) : image.image_url;
                const imageUrl = (imagePath || '').startsWith('uploads') ? `${baseUrl}${imagePath}` : `${baseUrl}uploads/${imagePath}`;
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.src = imageUrl;
                await new Promise((resolve, reject) => {
                    img.onload = resolve;
                    img.onerror = () => reject(new Error(`Failed to load image: ${imageUrl}`));
                });
                const scale = 4;
                const aspectRatio = img.height / img.width;
                const renderWidth = pdfPageWidth;
                const renderHeight = renderWidth * aspectRatio;
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = renderWidth * scale;
                canvas.height = renderHeight * scale;
                ctx.scale(scale, scale);
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';
                ctx.drawImage(img, 0, 0, renderWidth, renderHeight);
                const imgData = canvas.toDataURL('image/png', 1.0);
                if (i !== 0) pdf.addPage();
                const calculatedHeight = pdfPageWidth * aspectRatio;
                const finalHeight = calculatedHeight > pdfPageHeight ? pdfPageHeight : calculatedHeight;
                const finalWidth = finalHeight / aspectRatio;
                pdf.addImage(imgData, 'PNG', 0, 0, finalWidth, finalHeight, undefined, 'FAST');
            }
            pdf.save('edited_document.pdf');
            enqueueSnackbar('PDF downloaded successfully', { variant: 'success' });
        } catch (error) {
            console.error('Failed to download edited PDF', error);
            enqueueSnackbar(error?.message || 'Unable to download edited PDF', { variant: 'error' });
        }
    };


    return (
        <>
            {checkedItems.length > 0 &&(
                  <Box sx={{ mb: 3, display: 'flex', justifyContent: 'flex-end',gap:2,m:2.5,  }}>
                  <Typography  variant='subtitle1'>{checkedItems.length} selected</Typography>
                    <Button
                        disabled={ designOrder ? (!explodedPermissions?.some((permission) => ['Delete Design from Design Order Job'].includes(permission))) : false }
                        onClick={()=>handleDelete()} className={classes.delete} size='small' variant='outlined'
                    >
                        <Icon icon={trash2Outline} width={24} height={24} /> Delete
                    </Button>
                </Box>)}
                {data?.length>0 ?(
            <Grid className={classes.gridContainer} container spacing={2} pb={4}>
                {data?.map((attachment, index) => {
                    const attachmentId = attachment.ID || attachment.id;
                    const isImage = attachment?.not_approved_image === 1;
                    const documentSource = getDocumentSource(attachment);
                    
                    const fileName = attachment.file_url?.split('/').pop()?.split('?')[0] || attachment.name || 'File';
                    const fileExt = fileName.split('.').pop()?.toLowerCase();
                    const isPdf = fileExt === 'pdf' || attachment.file_type === 'application/pdf';
                    const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                    const googleViewerFormats = ['eps','ai','psd','tif','tiff','bmp','webp','ps','indd','indt'];
                    const isGoogleFormat = !['svg','txt','html','htm'].includes(fileExt) && googleViewerFormats.includes(fileExt);

                    return (
                        <Grid key={attachmentId} item xs={12} sm={4}>
                            {isImage ? (
                                <Box
                                    className={classes.attachmentBox}
                                    display="flex"
                                    alignItems="center"
                                    sx={{ position: 'relative' }}
                                >
                                    <AttachmentDownloadIconButton
                                        file={attachmentToFile(attachment)}
                                        fileIndex={index}
                                        hidden={!canDownloadFiles}
                                        sx={{ position: 'absolute', top: 8, left: 8, zIndex: 12 }}
                                    />
                                    <Box
                                        onClick={() => handleAttachmentClick(attachment)}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <img
                                            src={attachment.file_url}
                                            alt={attachment.name}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                borderRadius: 4,
                                            }}
                                        />
                                    </Box>
                                    <Box className={classes.checkboxContainer}>
                                        <Checkbox
                                            checked={checkedItems.includes(attachmentId)}
                                            onChange={() => handleCheckboxChange(attachmentId)}
                                            color="primary"
                                        />
                                    </Box>
                                </Box>
                            ) : (
                                <ImageListItem
                                    sx={{
                                        width: 240,
                                        overflow: 'hidden',
                                        position: 'relative',
                                        listStyle: 'none',
                                    }}
                                >
                                    <Box
                                        component="span"
                                        sx={{
                                            display: 'block',
                                            width: 240,
                                            height: 240,
                                            position: 'relative',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => handleAttachmentClick(attachment)}
                                    >
                                        <AttachmentDownloadIconButton
                                            file={attachmentToFile(attachment)}
                                            fileIndex={index}
                                            hidden={!canDownloadFiles}
                                            sx={{ position: 'absolute', top: 8, left: 8, zIndex: 12 }}
                                        />
                                            <>
                                              <Tooltip title={isPdf ? 'View PDF' : isGoogleFormat ? 'View Design' : 'View File'}>
                                                <IconButton
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleAttachmentClick(attachment);
                                                  }}
                                                  aria-label="open file"
                                                  sx={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    zIndex: 200,
                                                    color: theme.palette.error.main,
                                                    backgroundColor: theme.palette.text.primary,
                                                  }}
                                                >
                                                  {isOfficeFile ? (
                                                    <Description style={{ fontSize: 50, color: 'green' }} />
                                                  ) : isPdf ? (
                                                    <PictureAsPdf style={{ fontSize: 50, color: 'red' }} />
                                                  ) : isGoogleFormat ? (
                                                    <Description style={{ fontSize: 50, color: 'red' }} />
                                                  ) : (
                                                    <Description style={{ fontSize: 50, color: 'red' }} />
                                                  )}
                                                </IconButton>
                                              </Tooltip>
                                              {(() => {
                                                if (isOfficeFile) {
                                                  return (
                                                    <iframe
                                                      src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(attachment.file_url)}`}
                                                      title={fileName}
                                                      style={{ width: 240, height: 240, border: 0, pointerEvents: 'none' }}
                                                    />
                                                  );
                                                }
                                                
                                                if (isGoogleFormat) {
                                                  return (
                                                    <iframe
                                                      src={`https://docs.google.com/gview?url=${encodeURIComponent(attachment.file_url)}&embedded=true`}
                                                      title={fileName}
                                                      style={{ width: 240, height: 240, border: 0, pointerEvents: 'none' }}
                                                    />
                                                  );
                                                }
                                                
                                                return (
                                                  <iframe
                                                    src={attachment.file_url}
                                                    title={attachment.name}
                                                    style={{ width: 240, height: 240, border: 0, pointerEvents: 'none' }}
                                                  />
                                                );
                                              })()}
                                            </>
                                    </Box>
                                    <ImageListItemBar
                                        sx={{ width: '100%' }}
                                        subtitle={
                                            <Stack spacing={0.5}>
                                                <Typography variant="caption">
                                                    {attachment.timestamp
                                                        ? moment.unix(attachment.timestamp).format('MM/DD/YYYY')
                                                        : ''}
                                                </Typography>
                                                {isPdf && (
                                                <Accordion
                                                    square
                                                    disableGutters
                                                    elevation={0}
                                                    sx={{
                                                        backgroundColor: 'transparent',
                                                        '&:before': { display: 'none' },
                                                        minHeight: '18px',
                                                    }}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={
                                                            <ExpandMoreIcon sx={{ fontSize: 18, color: 'inherit' }} />
                                                        }
                                                        sx={{
                                                            minHeight: '18px',
                                                            px: 0,
                                                            '&.Mui-expanded': { minHeight: '18px' },
                                                            '& .MuiAccordionSummary-content': { margin: 0 },
                                                            '& .MuiAccordionSummary-content.Mui-expanded': {
                                                                margin: 0,
                                                            },
                                                        }}
                                                    >
                                                        <Typography variant="caption">{isPdf ? 'Edit PDF' : 'Edit File'}</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails sx={{ p: 0, pt: 1, pb: 0.5 }}>
                                                        <Stack direction="row" width="100%" spacing={1} sx={{ flexDirection: 'row' }}>
                                                            <Button
                                                                size="small"
                                                                variant="contained"
                                                                color="primary"
                                                                fullWidth
                                                                onClick={() => {
                                                                    setSelectedPDFForEdit({
                                                                        url: attachment.file_url,
                                                                        item: attachment,
                                                                    });
                                                                    setOpenPDFEditor(true);
                                                                }}
                                                                startIcon={<EditIcon sx={{ fontSize: 11 }} />}
                                                                sx={{
                                                                    textTransform: 'none',
                                                                    boxShadow: 'none',
                                                                    fontSize: '11px',
                                                                }}
                                                            >
                                                                Edit
                                                            </Button>
                                                            {/* <Button
                                                                size="small"
                                                                variant="outlined"
                                                                color="inherit"
                                                                onClick={() =>
                                                                    handleDownloadEditedPdf(attachmentId, documentSource)
                                                                }
                                                                sx={{ textTransform: 'none', fontSize: '11px' }}
                                                            >
                                                                Download Edited PDF
                                                            </Button> */}
                                                        </Stack>
                                                    </AccordionDetails>
                                                </Accordion>
                                                )}
                                            </Stack>
                                        }
                                    />
                                    <Box className={classes.checkboxContainer}>
                                        <Checkbox
                                            checked={checkedItems.includes(attachmentId)}
                                            onChange={() => handleCheckboxChange(attachmentId)}
                                            color="primary"
                                        />
                                    </Box>
                                </ImageListItem>
                            )}
                        </Grid>
                    );
                })}
            </Grid>):(
                <Box
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                py={15}
              >
                No files found
              </Box> 
            )}

            <AttachmentPreviewDialog
                open={open}
                onClose={() => {
                    setOpen(false);
                    setSelectedAttachment(null);
                }}
                fileUrl={selectedAttachment?.file_url}
                file={attachmentToFile(selectedAttachment)}
                isClient={isClient}
                userType={userType}
                pdfLoading={pdfLoading}
                setPdfLoading={setPdfLoading}
                useOfficeViewer={useOfficeViewer}
                setUseOfficeViewer={setUseOfficeViewer}
            />

            {openPDFEditor && selectedPDFForEdit && (
                <PDFEditor
                    open={openPDFEditor}
                    onClose={() => setOpenPDFEditor(false)}
                    pdfUrl={selectedPDFForEdit.url}
                    attachmentId={selectedPDFForEdit.item?.ID || selectedPDFForEdit.item?.id}
                    requestId={requestId}
                    onSaveSuccess={() => {
                        setRefresh(!refresh);
                    }}
                    documentSource={getDocumentSource(selectedPDFForEdit.item)}
                />
            )}
        </>
    );
}
